const common = {
  Save: '儲存',
  Add: '新增',
  Copy: '複製',
  'Copied to clipboard': '已複製到剪貼簿',
  'Something went wrong. Please try again.': '發生錯誤，請重新嘗試',
  Confirm: '確認',
  Cancel: '取消',
  Close: '關閉',
  Logout: '登出',
  'Upgrade now': '一鍵升級',
};

export default common;
